export default __webpack_public_path__ + "static/media/effy.881aad65.jpg";